import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetAccountInfoQuery, useUpdateMfaSetupStatusMutation } from 'views/utils/graphql/graphql';
import { checkNeedLoginPath } from 'views/constants/enums/pageTitle';
import { MFASetupStatus } from 'views/constants/enums/accountInfo';
import { checkPasskeySuggestHeader } from 'views/utils/checkHeaderPath';

export enum ForceInputStep {
  NotLogin,
  ChangePassword,
  MFASuggest,
  AgreementDocument,
}

export const useLayout = () => {
  const location = useLocation();
  const [step, setStep] = useState<ForceInputStep>(ForceInputStep.NotLogin);
  const isNeedLoginPath = checkNeedLoginPath(location.pathname);

  const [accountInfo, getAccountInfo] = useGetAccountInfoQuery({
    requestPolicy: 'network-only',
    pause: !isNeedLoginPath,
  });

  const [, updateMfaSetupStatus] = useUpdateMfaSetupStatusMutation();
  const showPasskeySuggestHeader =
    checkPasskeySuggestHeader(location.pathname) &&
    accountInfo.data?.GetAccountInfo?.MFASetupStatus === MFASetupStatus.NotSetup;

  useEffect(() => {
    if (!isNeedLoginPath) {
      setStep(ForceInputStep.NotLogin);
    }
  }, [isNeedLoginPath]);

  useEffect(() => {
    if (accountInfo.fetching) return;
    if (accountInfo.data?.GetAccountInfo?.ChangedPassword === false) {
      setStep(ForceInputStep.ChangePassword);
    } else if (accountInfo.data?.GetAccountInfo?.MFASetupStatus === MFASetupStatus.InitLogin) {
      setStep(ForceInputStep.MFASuggest);
    } else {
      setStep(ForceInputStep.AgreementDocument);
    }
  }, [accountInfo]);

  const changePasswordComplete = useCallback(() => {
    getAccountInfo();
  }, [getAccountInfo]);

  const mfaSuggestionComplete = useCallback(async () => {
    const res = await updateMfaSetupStatus({
      input: {
        Status: MFASetupStatus.NotSetup,
      },
    });
    if (res.data?.UpdateMFASetupStatus?.Code === 0) {
      getAccountInfo();
    }
    console.log(res.data?.UpdateMFASetupStatus?.Code);
  }, [getAccountInfo, updateMfaSetupStatus]);

  return {
    step,
    showPasskeySuggestHeader,
    changePasswordComplete,
    mfaSuggestionComplete,
  };
};
